// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"97742172","136":"d8dee4fc","371":"7e8c1698","785":"6a68f6d8"}[chunkId] + ".chunk.css";
};